import { STATUS_CODE, type StatusCode } from '@kc-console/core';
import {
  ActionTemporaryError,
  DefaultTemporaryError,
  NotFound,
  ServiceMaintenance,
} from '@kc-console/shared-ui';

import { FullPageErrorLayout } from './FullPageErrorLayout';

type FullPageErrorMapperProps = {
  status?: StatusCode;
};

/**
 * 전체 화면 에러 매퍼 컴포넌트
 *
 * @description
 * 상태 코드에 따라 적절한 전체 화면 에러 컴포넌트를 렌더링합니다.
 * FullPageErrorLayout으로 감싸서 표시됩니다.
 */
const FullPageErrorMapper = ({ status }: FullPageErrorMapperProps) => {
  const renderError = () => {
    if (status === STATUS_CODE.SERVICE_UNAVAILABLE) {
      return <ServiceMaintenance />;
    } else if (status === STATUS_CODE.INTERNAL_SERVER_ERROR) {
      return <ActionTemporaryError />;
    } else if (status === STATUS_CODE.NOT_FOUND) {
      return <NotFound />;
    } else {
      return <DefaultTemporaryError />;
    }
  };

  return <FullPageErrorLayout>{renderError()}</FullPageErrorLayout>;
};

export default FullPageErrorMapper;
